import { getInvoiceId } from 'services/api/common';

import { TableFilters } from '../filtersKeys';

export enum InvoicesFiltersKeys {
  EXPLOITATION_UNIT_NAME = 'exploitationUnit.name',
  IDENTIFIER = 'identifier',
  PO_NUMBER = 'poNumber',
  INVOICED_AT = 'invoicedAt',
  PRICE_WITH_TAXES = 'priceWithTaxes',
  PAYMENT_STATUS = 'paymentStatus',
  INVOICE_DUE_DATE = 'invoiceDueDate',
  OPEN_AMOUNT = 'openAmount',
  DOC_TYPE = 'docType',
}

export const INVOICES_FILTERS_INITIAL_VALUES: TableFilters = {
  [InvoicesFiltersKeys.EXPLOITATION_UNIT_NAME]: '',
  [InvoicesFiltersKeys.IDENTIFIER]: getInvoiceId(),
  [InvoicesFiltersKeys.PO_NUMBER]: '',
  [InvoicesFiltersKeys.INVOICED_AT]: { before: null, after: null },
  [InvoicesFiltersKeys.PRICE_WITH_TAXES]: { min: null, max: null },
  [InvoicesFiltersKeys.PAYMENT_STATUS]: '',
  [InvoicesFiltersKeys.INVOICE_DUE_DATE]: { before: null, after: null },
  [InvoicesFiltersKeys.OPEN_AMOUNT]: { min: null, max: null },
  [InvoicesFiltersKeys.DOC_TYPE]: '',
};
